module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tasks-index"
    }
  }, [_c('h1', {
    staticClass: "inline"
  }, [_vm._v("Tarefas")]), (!_vm.current_user.isMonitoringManager()) ? _c('button', {
    staticClass: "btn btn-clean pull-right",
    attrs: {
      "id": "new-task"
    },
    on: {
      "click": _vm.openTaskModalForm
    }
  }, [_c('span', {
    staticClass: "icon-more"
  }, [_vm._v("+")]), _vm._v("Nova tarefa")]) : _vm._e(), _c('div', {
    staticClass: "clear"
  }), _c('br'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('statistic-cards', {
    ref: "statistic_cards"
  })], 1)]), _c('br'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('filters', {
    attrs: {
      "filters": _vm.filters
    },
    on: {
      "filter": _vm.filter
    }
  })], 1)]), _c('div', {
    staticClass: "row relative"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "tasks-header tasks"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("Tarefas de Hoje")]), _c('span', {
    staticClass: "numbers today"
  }, [_vm._v(_vm._s(_vm.number_of_today_tasks))])]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("Tarefas em Atraso")]), _c('span', {
    staticClass: "numbers overdue"
  }, [_vm._v(_vm._s(_vm.number_of_overdue_tasks))])]), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("Tarefas Futuras")]), _c('span', {
    staticClass: "numbers future"
  }, [_vm._v(_vm._s(_vm.number_of_future_tasks))])])]), _c('div', {
    staticClass: "tasks-wrapper tasks"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('task-list', {
    ref: "today_tasks",
    attrs: {
      "filters": _vm.today_filter,
      "options": {
        tasks_status: 'today'
      },
      "item_options": {
        description: 'contact-info',
        width: 'full-width'
      }
    },
    on: {
      "number-of-tasks": _vm.numberOfTodayTasks,
      "open-template-modal": _vm.loadTaskInfo,
      "toggle-task-bar": _vm.toggleTaskBar
    }
  })], 1), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('task-list', {
    ref: "overdue_tasks",
    attrs: {
      "filters": _vm.overdue_filter,
      "options": {
        tasks_status: 'overdue'
      },
      "item_options": {
        description: 'contact-info',
        width: 'full-width'
      }
    },
    on: {
      "number-of-tasks": _vm.numberOfOverdueTasks,
      "open-template-modal": _vm.loadTaskInfo,
      "toggle-task-bar": _vm.toggleTaskBar
    }
  })], 1), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('task-list', {
    ref: "future_tasks",
    attrs: {
      "filters": _vm.future_filter,
      "options": {
        tasks_status: 'future'
      },
      "item_options": {
        description: 'contact-info',
        width: 'full-width'
      }
    },
    on: {
      "number-of-tasks": _vm.numberOfFutureTasks,
      "open-template-modal": _vm.loadTaskInfo,
      "toggle-task-bar": _vm.toggleTaskBar
    }
  })], 1)])]), _c('div', {
    staticClass: "clear"
  }), _c('br'), _c('div', {
    staticClass: "col-md-9"
  }, [_c('ozzy-tasks', {
    attrs: {
      "users_options": _vm.users_options
    },
    on: {
      "toggle-task-bar": _vm.toggleTaskBar
    }
  }), _c('div', {
    staticClass: "clear"
  }), _c('calendar')], 1), _c('live-feed', {
    class: {
      lower: _vm.current_user.isSeller()
    },
    attrs: {
      "users_options": _vm.users_options
    },
    on: {
      "toggle-task-bar": _vm.toggleTaskBar
    }
  })], 1), _c('task-modal-form', {
    on: {
      "destroyed": _vm.removeTask,
      "open-template-modal": _vm.loadTaskInfo
    }
  }), _c('div', {
    staticClass: "clear"
  }), _c('br'), _c('br'), _c('br'), _c('br'), _c('div', {
    staticClass: "grid-footer"
  }, [_c('div', {
    staticClass: "done-tasks"
  }, [_c('done-tasks-feed', {
    attrs: {
      "users_options": _vm.users_options
    },
    on: {
      "toggle-task-bar": _vm.toggleTaskBar
    }
  })], 1), _c('div', {
    staticClass: "paused-contacts"
  }, [_c('paused-contacts', {
    attrs: {
      "users_options": _vm.users_options
    },
    on: {
      "toggle-task-bar": _vm.toggleTaskBar
    }
  })], 1)]), (_vm.show_meeting_modal) ? _c('meeting-modal', {
    staticStyle: {
      "top": "30%",
      "left": "10%"
    },
    attrs: {
      "task": _vm.selected_task
    },
    on: {
      "close-meeting-modal": function($event) {
        return _vm.closeMeetingModal()
      }
    }
  }) : _vm._e(), _c('go-to-top')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8a8ce2b8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/index.vue
// module id = 1186
// module chunks = 1